module.exports = __webpack_public_path__ + "static/boyhamper-53499cc81744e930fcdefe78782b1b17.jpeg";